<template>
  <div class="calendar-wrapper">
    <div class="header" v-if="headerBar">
      <div class="left" @click="changeMonth('pre')"></div>
      <div>{{ y + '年' + formatNum(m) + '月' }}</div>
      <div class="right" @click="changeMonth('next')"></div>
    </div>
    <div class="week">
      <div class="week-day" v-for="(item, index) in weekDay" :key="index">{{ item }}</div>
    </div>
    <div :class="{ hide: !monthOpen }" class="content" :style="{ height: height }">
      <div :style="{ top: positionTop + 'rpx' }" class="days">
        <div class="item" v-for="(item, index) in dates" :key="index">
          <div
            class="day"
            @click="selectOne(item, $event)"
            :class="{
              choose: choose == `${item.year}-${item.month}-${item.date}` && item.isCurM,
              nolm: !item.isCurM,
              today: isToday(item.year, item.month, item.date),
              isWorkDay: isWorkDay(item.year, item.month, item.date),
            }"
          >
            {{ Number(item.date) }}
          </div>
          <div :class="[getStatus(item)]" class="markDay" v-if="isMarkDay(item.year, item.month, item.date) && item.isCurM" :style="isAbnormal(item.year, item.month, item.date) ? 'background:#FE923F' : ''"></div>
          <!-- <div class="today-text" v-if="isToday(item.year, item.month, item.date)">今</div> -->
        </div>
      </div>
    </div>
    <div class="toggle" v-if="collapsible" @click="toggle">
      <img src="https://i.loli.net/2020/07/16/2MmZsucVTlRjSwK.png" class="weektoggle" :class="{ down: monthOpen }" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ren-calendar',
  props: {
    // 星期几为第一天(0为星期日)
    weekstart: {
      type: Number,
      default: 0,
    },
    kqdkFlag:{
      type: Boolean,
      default:true,
    },
    yearAndMonthToSee:{
      type:String,
      default:new Date().getFullYear()+'-'+(new Date().getMonth() + 1)
    },
    // 标记的日期
    markDays: {
      type: Array,
      default: () => {
        return []
      },
    },
    //是否展示月份切换按钮
    headerBar: {
      type: Boolean,
      default: true,
    },
    // 是否展开
    open: {
      type: Boolean,
      default: true,
    },
    //是否可收缩
    collapsible: {
      type: Boolean,
      default: true,
    },
    //未来日期是否不可点击
    disabledAfter: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    yearAndMonthToSee:{
      handler(newVal,oldVal) {
        this.dates = this.monthDay(newVal.split("-")[0], newVal.split("-")[1]);
        !this.open && this.toggle()
      },
      deep: true,
      immediate:true
    }
  },
  data() {
    return {
      weektext: ['日', '一', '二', '三', '四', '五', '六'],
      y: new Date().getFullYear(), // 年
      m: new Date().getMonth() + 1, // 月
      dates: [], // 当前月的日期数据
      positionTop: 0,
      monthOpen: true,
      choose: '',
    }
  },
  created() {
    this.dates = this.monthDay(this.yearToSee.split("-")[0], this.monthToSee.split("-")[1]);
    !this.open && this.toggle()
  },
  mounted() {
      this.choose = this.getToday().date
  },
  computed: {
    // 顶部星期栏
    weekDay() {
      return this.weektext.slice(this.weekstart).concat(this.weektext.slice(0, this.weekstart))
    },
    height() {
      return (this.dates.length / 7) * 40 + 'px'
    },
    getStatus() {
      return item => {
        let index = this.markDays.findIndex(mark => mark.date == `${item.year}-${item.month}-${item.date}`)
        if (index != -1) {
          // console.log( this.markDays[index])
          if(this.markDays[index].signList != undefined){
            if(this.markDays[index].signList.length == 0||this.markDays[index].signList.length<this.markDays[index].dkcs){
              return 'noneMarkDay'
            }
          }
          if(this.markDays[index].hasDate != undefined){
            if(!this.markDays[index].hasDate){
              return 'noneMarkDay'
            } else {
              if(this.markDays[index].status == '2'){
                return 'markDayDone'
              }
            }
          }
        }
        return ''
      }
    },
  },
  methods: {
    formatNum(num) {
      let res = Number(num)
      return res < 10 ? '0' + res : res
    },
    getToday() {
      let date = new Date()
      let y = date.getFullYear()
      let m = date.getMonth()
      let d = date.getDate()
      let week = new Date().getDay()
      let weekText = ['日', '一', '二', '三', '四', '五', '六']
      let formatWeek = '星期' + weekText[week]
      let today = {
        date: y + '-' + this.formatNum(m + 1) + '-' + this.formatNum(d),
        week: formatWeek,
      }
      return today
    },
    // 获取当前月份数据
    monthDay(y, month) {
      let dates = []
      let m = Number(month)
      let firstDayOfMonth = new Date(y, m - 1, 1).getDay() // 当月第一天星期几
      let lastDateOfMonth = new Date(y, m, 0).getDate() // 当月最后一天
      let lastDayOfLastMonth = new Date(y, m - 1, 0).getDate() // 上一月的最后一天
      let weekstart = this.weekstart == 7 ? 0 : this.weekstart
      let startDay = (() => {
        // 周初有几天是上个月的
        if (firstDayOfMonth == weekstart) {
          return 0
        } else if (firstDayOfMonth > weekstart) {
          return firstDayOfMonth - weekstart
        } else {
          return 7 - weekstart + firstDayOfMonth
        }
      })()
      let endDay = 7 - ((startDay + lastDateOfMonth) % 7) // 结束还有几天是下个月的
      for (let i = 1; i <= startDay; i++) {
        dates.push({
          date: this.formatNum(lastDayOfLastMonth - startDay + i),
          day: weekstart + i - 1 || 7,
          month: m - 1 >= 0 ? this.formatNum(m - 1) : 12,
          year: m - 1 >= 0 ? y : y - 1,
        })
      }
      for (let j = 1; j <= lastDateOfMonth; j++) {
        dates.push({
          date: this.formatNum(j),
          day: (j % 7) + firstDayOfMonth - 1 || 7,
          month: this.formatNum(m),
          year: y,
          isCurM: true, //是否当前月份
        })
      }
      for (let k = 1; k <= endDay; k++) {
        dates.push({
          date: this.formatNum(k),
          day: (lastDateOfMonth + startDay + weekstart + k - 1) % 7 || 7,
          month: m + 1 <= 11 ? this.formatNum(m + 1) : 0,
          year: m + 1 <= 11 ? y : y + 1,
        })
      }
      return dates
    },
    isWorkDay(y, m, d) {
      //是否工作日
      let ymd = `${y}/${m}/${d}`
      let formatDY = new Date(ymd.replace(/-/g, '/'))
      let week = formatDY.getDay()
      if (week == 0 || week == 6) {
        return false
      } else {
        return true
      }
    },
    isFutureDay(y, m, d) {
      //是否未来日期
      let ymd = `${y}/${m}/${d}`
      let formatDY = new Date(ymd.replace(/-/g, '/'))
      let showTime = formatDY.getTime()
      let curTime = new Date().getTime()
      if (showTime > curTime) {
        return true
      } else {
        return false
      }
    },
    // 标记日期
    isMarkDay(y, m, d) {
      let flag = false
      for (let i = 0; i < this.markDays.length; i++) {
        let dy = `${y}-${m}-${d}`
        if (this.markDays[i].date == dy) {
          flag = true
          break
        }
      }
      return flag
    },
    isAbnormal(y, m, d) {
      let flag = false
      let dy = `${y}-${m}-${d}`
      for (let i = 0; i < this.markDays.length; i++) {
        if (this.markDays[i].date == dy && this.markDays[i].type == 2) {
          flag = true
          break
        }
      }
      return flag
    },
    isToday(y, m, d) {
      if(!this.kqdkFlag){
        return false;
      }
      let checkD = y + '-' + m + '-' + d
      let today = this.getToday().date
      if (checkD == today) {
        return true
      } else {
        return false
      }
    },
    // 展开收起
    toggle() {
      this.monthOpen = !this.monthOpen
      if (this.monthOpen) {
        this.positionTop = 0
      } else {
        let index = -1
        this.dates.forEach((i, x) => {
          this.isToday(i.year, i.month, i.date) && (index = x)
        })
        this.positionTop = -((Math.ceil((index + 1) / 7) || 1) - 1) * 80
      }
    },
    // 点击回调
    selectOne(i, event) {
      let date = `${i.year}-${i.month}-${i.date}`
      let selectD = new Date(date).getTime()
      let curTime = new Date().getTime()
      let week = new Date(date).getDay()
      let weekText = ['日', '一', '二', '三', '四', '五', '六']
      let formatWeek = '星期' + weekText[week]
      let response = {
        date: date,
        week: formatWeek,
      }
      if (!i.isCurM) {
        // console.log('不在当前月范围内');
        return false
      }
      if (selectD > curTime) {
        if (this.disabledAfter) {
          console.log('未来日期不可选')
          return false
        } else {
          this.choose = date
          this.$emit('onDayClick', response)
        }
      } else {
        this.choose = date
        this.$emit('onDayClick', response)
      }
      // console.log(response)
    },
    //改变年月
    changYearMonth(y, m) {
      this.dates = this.monthDay(y, m)
      this.y = y
      this.m = m
    },
    changeMonth(type) {
      if (type == 'pre') {
        if (this.m + 1 == 2) {
          this.m = 12
          this.y = this.y - 1
        } else {
          this.m = this.m - 1
        }
      } else {
        if (this.m + 1 == 13) {
          this.m = 1
          this.y = this.y + 1
        } else {
          this.m = this.m + 1
        }
      }
      this.dates = this.monthDay(this.y, this.m)
      this.$emit('changeMonth', this.m, this.y)
    },
  },
}
</script>

<style lang="less" scoped>
.calendar-wrapper {
  color: #bbb7b7;
  font-size: 14px;
  text-align: center;
  background-color: #fff;
  padding-bottom: 5px;

  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    color: #42464a;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #f2f2f2;
    position: relative;

    .left {
      position: absolute;
      left: 20px;
      top: 20px;
      // background: url('../../static/right-arrow.png')no-repeat center/cover;
      width: 7px;
      height: 12px;
      transform: rotate(180deg);

      &::after {
        content: '';

        position: absolute;

        top: -10px;

        left: -10px;

        right: -10px;

        bottom: -10px;
      }
    }

    .right {
      position: absolute;
      right: 20px;
      top: 20px;
      // background: url('../../static/right-arrow.png')no-repeat center/cover;
      width: 7px;
      height: 12px;

      &::after {
        content: '';

        position: absolute;

        top: -10px;

        left: -10px;

        right: -10px;

        bottom: -10px;
      }
    }
  }

  .week {
    display: flex;
    align-items: center;
    height: 40px;
    line-height: 4px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    div {
      flex: 1;
    }
  }

  .content {
    position: relative;
    overflow: hidden;
    transition: height 0.4s ease;

    .days {
      transition: top 0.3s;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      position: relative;

      .item {
        position: relative;
        display: block;
        height: 40px;
        line-height: 40px;
        width: calc(100% / 7);
        .day {
          font-style: normal;
          display: inline-block;
          vertical-align: middle;
          width: 30px;
          height: 30px;
          line-height: 30px;
          overflow: hidden;
          border-radius: 30px;
        }
        .choose {
          background-color: #4d7df9;
          color: #fff !important;
        }
        .nolm {
          color: #fff;
          opacity: 0.3;
        }
        .isWorkDay {
          color: #42464a;
        }
        .notSigned {
          font-style: normal;
          width: 4px;
          height: 4px;
          background: #fa7268;
          border-radius: 5px;
          position: absolute;
          left: 50%;
          bottom: 0;
          pointer-events: none;
        }
        .today {
          color: #fff;
          background-color: #a8c0ff;
        }
        .workDay {
          font-style: normal;
          width: 4px;
          height: 4px;
          background: #4d7df9;
          border-radius: 5px;
          position: absolute;
          left: 50%;
          bottom: 0;
          pointer-events: none;
        }

        .markDay {
          font-style: normal;
          width: 4px;
          height: 4px;
          background: #0189f9;
          border-radius: 5px;
          position: absolute;
          left: 50%;
          bottom: 5px;
          pointer-events: none;
          transform: translateX(-2px);
        }
        .noneMarkDay {
          background: #fe923f;
        }
        .markDayDone{
          background: #15BB83;
        }
      }
    }
  }

  .hide {
    height: 40px !important;
  }

  .toggle {
    line-height: 30px;
    height: 30px;

    .weektoggle {
      width: 42px;
      height: 16px;
      position: relative;
      bottom: -18px;

      &.down {
        transform: rotate(180deg);
        bottom: -6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/components/calendar.vue